import AddAutomaticallyButton from './AddAutomaticallyButton';
import AddNewTableEntryButton from './AddNewTableEntryButton';
import DownloadCSVButton from './DownloadCSVButton';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { TrackerDataType } from '../../shared/constants/constants';
import QueryAdderDrawer from '../QueryAdder/QueryAdderDrawer';
import BulkEditQueryAdder from '../QueryAdder/BulkEditQueryAdder';
import EditPencilIcon from '../TrackerFilter/Icons/EditPencilIcon';

export const TrackerTableActionButtons = (props) => {
  const {
    eventHandler,
    dropdownTable,
    currMonth,
    rows,
    isBulkEdit,
    selectedBulkEditRowIds,
    selectedBulkEditRowsCount,
    onSwitchToBulkEditView,
    onSwitchToMonthlyView,
    hasAutoAdd = true,
  } = props;

  const [openBulkEditPopup, setOpenBulkEditPopup] = useState(false);

  const getComponentColor = () => {
    switch (eventHandler.type) {
      case TrackerDataType.MEDIA_INTERACTION:
        return 'mediaInteraction';
      case TrackerDataType.SERVICE:
        return 'primary';
      case TrackerDataType.ENGAGEMENT:
        return 'primaryLighter';
      default:
        return 'primary';
    }
  };

  const getRowType = () => {
    switch (eventHandler.type) {
      case TrackerDataType.MEDIA_INTERACTION:
        return selectedBulkEditRowsCount > 1 ? 'Interactions' : 'Interaction';
      case TrackerDataType.SERVICE:
        return selectedBulkEditRowsCount > 1 ? 'Services' : 'Service';
      case TrackerDataType.ENGAGEMENT:
        return selectedBulkEditRowsCount > 1 ? 'Engagements' : 'Engagement';
      default:
        return selectedBulkEditRowsCount > 1 ? 'Items' : 'Item';
    }
  };

  if (!isBulkEdit) {
    return (
      <>
        {hasAutoAdd && <AddAutomaticallyButton eventHandler={eventHandler} />}
        <AddNewTableEntryButton dropdownTable={dropdownTable} eventHandler={eventHandler} currMonth={currMonth} />
        <Button
          variant="contained"
          color={getComponentColor()}
          sx={{ height: '100%' }}
          onClick={() => onSwitchToBulkEditView()}
          data-cy="openBulkEditViewButton"
          startIcon={<EditPencilIcon />}
        >
          Multiple
        </Button>
        <DownloadCSVButton
          rows={rows}
          dropdowns={dropdownTable}
          flattenerCallback={eventHandler.flattenForExport}
          filename={eventHandler.type}
          eventHandlerType={eventHandler.type}
        />
      </>
    );
  }

  return (
    <>
      <Button
        variant="contained"
        color={getComponentColor()}
        sx={{ height: '100%' }}
        disabled={selectedBulkEditRowsCount === 0}
        onClick={() => setOpenBulkEditPopup(true)}
        data-cy="openBulkEditPopupButton"
      >
        Edit {selectedBulkEditRowsCount} {getRowType()}
      </Button>
      <Button
        variant="outlined"
        color={getComponentColor()}
        sx={{ height: '100%' }}
        onClick={() => onSwitchToMonthlyView()}
        data-cy="cancelBulkEditViewButton"
      >
        Cancel
      </Button>
      <QueryAdderDrawer openForm={openBulkEditPopup} setOpenForm={setOpenBulkEditPopup}>
        <BulkEditQueryAdder
          selectedBulkEditRowIds={selectedBulkEditRowIds}
          eventHandler={eventHandler}
          dropdownTable={dropdownTable}
          currMonth={currMonth}
          rowType={getRowType()}
          onClose={() => setOpenBulkEditPopup(false)}
        />
      </QueryAdderDrawer>
    </>
  );
};
